import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";
import { useState, useEffect, useCallback } from "react";
import { pdf } from "@react-pdf/renderer";
import { setAppError } from "../../../../store/userSlice";
import OnArrival_New from "./newPDF_On arrival";
import { useDispatch } from "react-redux";

export default function DownloadPopUp_OnArrival({
  downloadPDF,
  SetDownloadPDF,
  downloadPDFdata,
  summaryProp,
  clientDetails,
}) {
  console.log(
    "Data to be printed here..",
    downloadPDFdata,
    summaryProp,
    clientDetails
  );
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [pdfData, setPdfData] = useState(null); // Store the PDF data here
  const [pdfName, setPdfName] = useState(""); // Store the name of the PDF
  const [downloadUrl, setDownloadUrl] = useState(""); // Store the download URL
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  // Effect to handle button disabling when popup is open
  useEffect(() => {
    if (downloadPDF) {
      setIsButtonDisabled(true); // Disable buttons when popup is open
      const timer = setTimeout(() => {
        setIsButtonDisabled(false); // Enable buttons after 3 seconds
      }, 3000);

      return () => clearTimeout(timer);
    } else {
      // Reset states and trigger re-render when popup is closed
      setPdfData(null); // Clear PDF data
      setDownloadUrl(""); // Clear download URL
    }
  }, [downloadPDF]);

  const downloadPaymentReceipt = async (value) => {
    try {
      const response = await nodeinstance.get(
        `/dashboard/visaSecOnArrival/downloadZip/${downloadPDFdata?.contract_id}/${downloadPDFdata.id}/${value}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response", response);
      if (response.status === 200) {
        // const blob = await response.blob();
        const contentType = response.headers["content-type"];
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${value}_INVOICE.zip`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
    return;
  };

  const [data, setData] = useState([]);

  // Data sets for 2 rows and 10 rows
  let smallData = [
    {
      Header: "Invoice Details",
      value: "",
      Artabic: "تفاصيل الفاتـــــــــــــورة",
    },
    {
      Header: "Request Date",
      value: new Date()
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .split(" ")
        .join("-")
        .toUpperCase(),
      Artabic: "تاريخ الفاتورة الأولية",
    },
    {
      Header: "Request No.",
      value: downloadPDFdata.invoice_no || "",
      Artabic: "رقم الفاتورة الأولية",
    },
    {
      Header: "Contract Number #",
      value: summaryProp?.contract_number || "",
      Artabic: "رقم العقد",
    },
    {
      Header: `${downloadPDFdata.months} months Security Deposit for ${downloadPDFdata.quantity} candidates`,
      value: downloadPDFdata.invoice_amount,
      Artabic: "وديعة تأمين لمدة شهر لـ <XX> مرشح",
    },
    {
      Header: "Total Amount",
      value: downloadPDFdata.invoice_amount,
      Artabic: "المبلغ الإجمالي",
    },
  ];

  const generatePDF = useCallback(async (data, name) => {
    setData(data);
    setPdfName(name);

    try {
      const blob = await pdf(
        <OnArrival_New
          data={data}
          clientDetails={clientDetails}
          valueChange={downloadPDFdata.invoice_type}
          header={name}
        />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      setDownloadUrl(url); // Set the download URL

      // Optional: Automatically click to download (depending on how you want to handle)
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      URL.revokeObjectURL(url); // Clean up
    } catch (error) {
      console.error("Error generating PDF", error);
    }
  }, []);

  let largeData = [
    {
      Header: "Invoice details.",
      value: "",
      Artabic: "تفاصيل الفاتـــــــــــــورة",
    },
    {
      Header: "Invoice Date",
      value: new Date()
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .split(" ")
        .join("-")
        .toUpperCase(),
      Artabic: "تاريخ اصدار الفاتورة",
    },
    {
      Header: "Invoice No.",
      value: downloadPDFdata?.invoice_no || "",
      Artabic: "رقم الفاتورة",
    },
    {
      Header: "Invoice for",
      value: "VISA COST",
      Artabic: "فاتورة الخدمات المنفذة فى شهر",
    },
    {
      Header: "Customer VAT Number",
      value: clientDetails && clientDetails[0]?.vat_number,
      Artabic: "الرقــم الضريبــى للعميل",
    },
    {
      Header: "Contract Number #",
      value: summaryProp?.contract_number || "",
      Artabic: "رقم العقد",
    },
    {
      Header: "Taxable amount Service charges",
      value:
        parseInt(downloadPDFdata.invoice_amount) -
        parseInt(downloadPDFdata.Vat_Amount),
      Artabic: "مبلغ خاضع للضريبة",
    },
    {
      Header: "Non-Taxable Amount - SAR",
      value: "",
      Artabic: "مبلغ غير خاضع للضريبة",
    },
    {
      Header: "VAT Amount 15% - SAR",
      value: downloadPDFdata.Vat_Amount,
      Artabic: "15قيمة الضريبة%",
    },
    {
      Header: "Total Invoice Amount - SAR",
      value: downloadPDFdata.invoice_amount,
      Artabic: "المبلغ الأجمالى للفاتورة",
    },
    {
      Header: "VAT # for Soundlines Administrative Co.",
      value: clientDetails && clientDetails[0]?.vat_number,
      Artabic: "لرقم الضريبى لشركة ساوندلاينز الإداريه",
    },
  ];

  const generateSmallPDF = (name) => {
    generatePDF(smallData, `${name}`);
  };

  const generateLargePDF = (name) => {
    generatePDF(largeData, `${name}`);
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
        downloadPDF ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-lg w-full h-[250px] overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative">
        <div className="flex justify-between items-center w-full">
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              SetDownloadPDF(false);
            }}
          >
            <IoMdClose />
          </h1>
        </div>
        {downloadPDFdata.invoice_type === "VISA COST" ? (
          <>
            <div className="flex items-center justify-between mt-4">
              <label htmlFor="" className="px-1">
                Generate Proforma Invoice
              </label>
              <div className="flex space-x-2">
                <button
                  onClick={() => generateLargePDF("PROFORMA INVOICE")}
                  className="px-4 py-2 bg-blue text-white rounded"
                  disabled={isButtonDisabled}
                >
                  Download
                </button>
              </div>
            </div>
            <div className="flex items-center justify-between mt-4">
              <label htmlFor="" className="px-1">
                Generate Invoice
              </label>
              <div className="flex space-x-2">
                <button
                  onClick={() => generateLargePDF("INVOICE")}
                  className="px-4 py-2 bg-blue text-white rounded"
                  disabled={isButtonDisabled}
                >
                  Download
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className="flex items-center justify-between mt-4">
            <label htmlFor="" className="px-1">
              Sec Deposit
            </label>
            <div className="flex space-x-2">
              <button
                onClick={() => generateSmallPDF("REQUEST FOR SECURITY DEPOSIT")}
                className="px-4 py-2 bg-blue text-white rounded"
                disabled={isButtonDisabled}
              >
                Download
              </button>
            </div>
          </div>
        )}
        {downloadUrl && (
          <div className="mt-4">
            <a href={downloadUrl} download={pdfName} className="hidden">
              Download PDF
            </a>
          </div>
        )}
        <div className="flex items-center justify-between mt-4">
          <div>
            <label htmlFor="" className="px-1">
              Download TAX Invoice:
            </label>
          </div>
          <div>
            <button
              className={`p-2 px-4 rounded-md ${
                isButtonDisabled ? "bg-gray-400" : "bg-blue"
              } text-white min-w-fit text-sm flex items-center gap-2`}
              style={{ pointerEvents: isButtonDisabled ? "none" : "auto" }}
              onClick={() => {
                downloadPaymentReceipt("TAX");
              }}
            >
              Download
            </button>
          </div>
        </div>

        <div className="flex items-center justify-between mt-4">
          <div>
            <label htmlFor="" className="px-1">
              Download PAYMENT RECEIPT:
            </label>
          </div>
          <div>
            <button
              className={`p-2 px-4 rounded-md ${
                isButtonDisabled ? "bg-gray-400" : "bg-blue"
              } text-white min-w-fit text-sm flex items-center gap-2`}
              style={{ pointerEvents: isButtonDisabled ? "none" : "auto" }}
              onClick={() => {
                downloadPaymentReceipt("PAYMENT");
              }}
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
